module.exports = __webpack_public_path__ + "media/icons/en-c649a42bf93a4335eccc2e116d78271e.svg";